/** Phase E (ximen package): Ximending and Longshan Temple / Wanhua. Lines marked “English practice” stay in English in every locale. */
export const enXimen = {
  ximen: {
    mapNames: {
      ximen: 'Ximending',
      longshan: 'Longshan Temple',
    },
    zones: {
      ximen: 'Ximending',
      longshan: 'Longshan Temple · Wanhua',
      xmCinemaPark: 'Taipei Cinema Park',
      xmCinemaStreet: 'Cinema Street (電影街)',
      xmSquare: 'Busker Square',
      xmEmei: 'Emei Street',
      xmExit6: 'Ximen MRT · Exit 6',
      xmRedHouse: 'The Red House (西門紅樓)',
      xmChengdu: 'Chengdu Road',
      xmZhonghua: 'Zhonghua Road',
      xmTemple: 'Bangka Longshan Temple',
      xmHerbAlley: 'Herb Alley (青草巷)',
      xmHuaxi: 'Huaxi Street Night Market',
      xmBopiliao: 'Bopiliao Historic Block',
      xmOldWanhua: 'Old Wanhua',
      xmBangka: 'Bangka Park',
    },
    objects: {
      xm_exit6: 'MRT Exit 6',
      xm_mapBoard: 'District map',
      xm_meesua: 'Mee sua stall',
      xm_chicken: 'Chicken cutlet stand',
      xm_ice: 'Shaved ice counter',
      xm_sticker: 'Photo sticker booth',
      xm_tea: 'Bubble tea shop',
      xm_claw: 'Claw machines',
      xm_cinema: 'Cinema box office',
      xm_posters: 'Movie posters',
      xm_sneakers: 'Sneaker rack',
      xm_clothes: 'Clothes rack',
      xm_tattoo: 'Tattoo studio sign',
      xm_busker: 'Street performer',
      xm_screen: 'Giant video screen',
      xm_plaque: 'Ximending ground plaque',
      xm_graffiti: 'Graffiti wall',
      xm_redHouse: 'The Red House',
      xm_market: 'Weekend creative market',
      xm_mrtL: 'Longshan Temple MRT station',
      xm_dragonDoor: 'Dragon Door (entrance)',
      xm_pillar: 'Bronze dragon pillars',
      xm_waterfall: 'Waterfall garden',
      xm_burner: 'Great incense burner',
      xm_offer: 'Offerings table',
      xm_moon: 'Moon blocks',
      xm_sticks: 'Fortune sticks',
      xm_roof: 'Swallowtail roof',
      xm_herbTea: 'Herbal tea stall',
      xm_herbSign: 'Herb Alley sign',
      xm_bopiliao: 'Bopiliao history board',
      xm_huaxi: 'Huaxi Street gate',
      xm_hxNoodle: 'Danzai noodle stall',
      xm_hxSoup: 'Four-herb soup stall',
      xm_chess: 'Chinese chess table',
      xm_pigeons: 'Pigeons',
      xm_canoe: 'Canoe sculpture',
      xm_fortune: 'Fortune-teller’s table',
      xm_oldIce: 'Old ice shop',
    },
    npc: {
      xm_teen1: 'Waiting teen',
      xm_teen2: 'Teen with a phone',
      xm_teen3: 'Teen in a cap',
      xm_meesuaLady: 'Mee sua auntie',
      xm_tourist: 'Lost tourist',
      xm_shopper1: 'Shopper',
      xm_shopper2: 'Sneaker fan',
      xm_skater: 'Skater',
      xm_artist: 'Market artist',
      xm_redGuide: 'Red House guide',
      xm_cosplayer: 'Cosplayer',
      xm_grandpaX: 'Old movie fan',
      xm_volunteer: 'Temple volunteer',
      xm_fortuneGrandpa: 'Fortune-teller grandpa',
      xm_worshipper1: 'Worshipper',
      xm_worshipper2: 'Grandma with incense',
      xm_incenseAuntie: 'Incense seller',
      xm_herbLady: 'Herb tea lady',
      xm_chess1: 'Chess grandpa',
      xm_chess2: 'Chess watcher',
      xm_pigeonKid: 'Pigeon-watching kid',
      xm_bopiliaoGuide: 'History student',
      xm_nightVendor: 'Night-market cook',
      xm_tourist2: 'Visitor from abroad',
      xm_taichi: 'Tai chi grandma',
    },
    items: {} as Record<string, { name: string; desc: string }>,

    common: {
      learned: '📘 You learned something new!',
      closed: 'Closed now. The night market opens in the evening (from 5 pm).',
      notEnough: 'You don’t have enough coins.',
      back: 'Back',
    },

    // --- Ximending --------------------------------------------------------------------------
    exit6: {
      text: 'Ximen MRT Exit 6: the most famous meeting point in Taipei. Teenagers wait here for their friends every weekend.',
      phrase: 'Let’s meet at Exit 6!', // English practice
      ride: '🚇 Take the MRT',
      practice: '🗣️ Practise meeting in English',
      q: 'Your friend asks: “Where shall we meet?”', // English practice
      a: ['Let’s meet at Exit 6 at three o’clock.', 'Meet you yesterday at the train.', 'I am Exit 6.'], // English practice
      right: '✅ Perfect! Say the place and the time. Your friend replies: “See you there!”',
      wrong: 'Hmm, that sounds strange. Say the place and the time!',
    },
    mapBoard: {
      text: 'A map of Ximending: Cinema Street at the top, Emei Street in the middle, Exit 6 and the Red House at the bottom.',
      q: 'You are at Exit 6. How do you go to the Red House?', // English practice
      a: ['Cross Chengdu Road. It’s on the other side.', 'Take the escalator up to the sky.', 'Go inside the cinema.'], // English practice
      right: '✅ Yes! The Red House is right across the road from Exit 6.',
      wrong: 'Look at the map again: the red building is across the big road.',
    },
    meesua: {
      vendor: 'Hello! Big bowl or small bowl?', // English practice
      ok: 'A small bowl of mee sua, please.', // English practice
      bad: ['Give me noodle now!', 'I am a small bowl.'], // English practice
      done: 'Here you go! Here we eat it standing up, with a spoon — no chopsticks. Careful, it’s hot!', // English practice
      after: 'Mee sua (麵線) is a thin noodle soup with pork intestine and lots of garlic. There are no seats: everybody eats standing on the street!',
    },
    tea: {
      vendor: 'Hi! What would you like? How sweet, and how much ice?', // English practice
      ok: 'A bubble milk tea, half sugar, less ice, please.', // English practice
      bad: ['Sugar me, please!', 'I want a hot ice cold tea big.'], // English practice
      done: 'One bubble milk tea, half sugar, less ice! Shake it before you drink!', // English practice
    },
    chicken: {
      vendor: 'Welcome! Spicy or not spicy? Shall I cut it?', // English practice
      ok: 'One chicken cutlet, not spicy, cut, please.', // English practice
      bad: ['Chicken! Chicken! Chicken!', 'Not cut spicy me chicken.'], // English practice
      done: 'Here you are! It’s bigger than your face!', // English practice
    },
    ice: {
      vendor: 'Hello! Mango or strawberry shaved ice?', // English practice
      ok: 'Could I have a mango shaved ice, please?', // English practice
      bad: ['Mango me!', 'I would like a hot snow, please.'], // English practice
      done: 'One mango shaved ice! It’s big — share it with a friend!', // English practice
    },
    claw: {
      text: 'A whole shop of claw machines (夾娃娃機). Ten coins a try. The claw is tricky!',
      play: '🧸 Play (10 coins)',
    },
    cinema: {
      text: 'Ximending has been Taipei’s movie street for a hundred years. Which film do you want to see?',
      films: ['Space Cat', 'Boba Quest', 'Robo Fu'],
      vendor: 'Hi! Which movie, and how many tickets?', // English practice
      ok: 'One ticket for {film}, please.', // English practice
      bad: ['Movie! One! Me!', 'I am a ticket for {film}.'], // English practice
      done: 'Here’s your ticket for {film}. Enjoy the movie!', // English practice
      watched: '🍿 You watched {film}. What a fun film!',
    },
    posters: {
      text: 'Three posters: SPACE CAT — “A brave cat flies to the moon.” BOBA QUEST — “Two friends look for the best bubble tea.” TYPHOON! — “A family stays home in the storm.”', // English practice
      q: 'Who flies to the moon?', // English practice
      a: ['A brave cat.', 'Two friends.', 'A family.'], // English practice
      right: '✅ Right! Space Cat is about a brave cat.',
      wrong: 'Read the posters again!',
    },
    sneakers: {
      text: 'Rows of colourful sneakers. The ones you like are too small…',
      q: 'How do you ask for another size?', // English practice
      a: ['Do you have these in a bigger size?', 'Shoes bigger you have?', 'I size the shoes, please.'], // English practice
      right: '✅ Great! The clerk smiles: “Sure, let me check!”', // English practice
      wrong: 'Try a polite question with “Do you have…?”',
    },
    clothes: {
      text: 'A sale rack of T-shirts in every colour. You like the yellow one.',
      q: 'How do you ask to try it on?', // English practice
      a: ['Can I try this on, please?', 'I try you on.', 'This is on me?'], // English practice
      right: '✅ Yes! “The fitting room is at the back.”', // English practice
      wrong: 'Hmm. Start with “Can I…?”',
    },
    tattoo: {
      text: 'A tattoo studio. Real tattoos are only for adults (18+)… but the artist offers to draw a temporary star on your hand!',
      get: '⭐ A temporary star (10 coins)',
      done: 'A sparkly star on your hand! “Temporary” means it washes off in a few days.', // English practice
    },
    sticker: {
      text: 'A photo sticker booth (大頭貼)! Pick a frame and pose. 30 coins.',
      frames: ['🌸 Flowers', '🐱 Cat ears', '✨ Sparkles'],
      cheese: 'Say cheese!', // English practice
      done: 'Click! Out come the stickers: big eyes, sparkles and your best smile.',
    },
    busker: {
      dancer: 'A street dancer pops and spins to the music. A crowd gathers in a circle.',
      singer: 'A singer with a guitar plays a soft song. People sway and film with their phones.',
      none: 'Nobody is performing now. Street artists in Ximending need a licence; they perform from late morning until night.',
      watch: '👀 Watch the show',
      tip: '🪙 Tip 10 coins',
      cheer: 'That was amazing!', // English practice
      watched: '👏 You clapped along with the crowd!',
      thanks: 'The performer bows: “Thank you so much!”', // English practice
    },
    screen: {
      text: 'The giant screen flashes adverts all day: a concert, a new game, and a bubble tea ad that says “BUBBLE TEA NT$50”.', // English practice
      q: 'How much is the bubble tea in the ad?', // English practice
      a: ['Fifty dollars.', 'Fifteen dollars.', 'Five hundred dollars.'], // English practice
      right: '✅ Right: fifty (50). Careful: fifteen is 15!',
      wrong: 'Look again: 5 and 0…',
    },
    plaque: {
      text: '“Ximen” (西門) means West Gate: the west gate of old Taipei’s city wall stood near here. Ximending (西門町) is the West Gate District.',
      phrase: 'Ximending means West Gate District.', // English practice
    },
    graffiti: {
      text: 'At Taipei Cinema Park, painting on this wall is allowed: artists cover it with new graffiti all the time.',
      q: 'What colour is the word 西門?', // English practice
      a: ['Pink.', 'Green.', 'Black.'], // English practice
      right: '✅ Yes, bright pink!',
      wrong: 'Look at the first piece on the left!',
    },
    redHouse: {
      text: 'The Red House (西門紅樓) was built in 1908 as Taiwan’s first public market. Its front is an octagon, with a cross-shaped hall behind it. Today it’s full of little shops by young designers.',
      q: 'How many sides does an octagon have?', // English practice
      a: ['Eight.', 'Six.', 'Ten.'], // English practice
      right: '✅ Eight! “Octo” means eight — like an octopus with eight arms.',
      wrong: 'Count the sides of the front building!',
    },
    market: {
      text: 'The weekend creative market: handmade keychains, postcards, jewellery and tea.',
      q: 'You like a keychain. What do you say?', // English practice
      a: ['How much is this keychain?', 'Keychain money you?', 'I am a keychain.'], // English practice
      right: '✅ “It’s 30 dollars. I made it myself!”', // English practice
      wrong: 'Try “How much is…?”',
      buy: '🔑 Buy the keychain (30 coins)',
      bought: 'You bought a handmade keychain!',
    },

    // --- Longshan Temple ------------------------------------------------------------------
    mrtL: {
      text: 'Longshan Temple station. The exit comes up right in Bangka Park, across the road from the temple.',
      ride: '🚇 Take the MRT',
    },
    etiquette: {
      intro: 'Before you go in, the volunteer checks you know the temple manners.',
      qs: [
        { q: 'Which door do you use to go IN?', a: ['The right door — the Dragon Door.', 'The middle door.', 'The left door — the Tiger Door.'] }, // English practice
        { q: 'And which door do you use to go OUT?', a: ['The left door — the Tiger Door.', 'The Dragon Door again.', 'Through the window.'] }, // English practice
        { q: 'Can you step on the wooden door sill?', a: ['No, step over it.', 'Yes, jump on it.', 'Sit on it.'] }, // English practice
      ],
      right: '✅ Correct!',
      wrong: '❌ Not quite. Remember: in by the dragon, out by the tiger!',
      done: 'Well done! “Enter by the right door (dragon side), exit by the left (tiger side).” The middle door is for the gods.', // English practice
    },
    pillar: {
      text: 'A rare pair of bronze dragon pillars guards the main door: each one has a dragon coiling up to the roof.',
      q: 'What are these pillars made of?', // English practice
      a: ['Bronze — a metal.', 'Wood.', 'Chocolate.'], // English practice
      right: '✅ Bronze! Touch it gently: it’s cool and smooth.',
      wrong: 'Hmm. They are dark and shiny like old coins…',
    },
    waterfall: {
      text: 'A little waterfall falls into a koi pond at the temple entrance. The sound of water helps people feel calm before they pray.',
      phrase: 'The water sounds so peaceful.', // English practice
    },
    burner: {
      text: 'The great incense burner (天公爐) is for the Jade Emperor, the god of heaven. People hold incense with both hands, bow three times and make a quiet wish.',
      bow: '🙏 Bow three times and make a wish',
      wish: 'I wish my family good health.', // English practice
      done: 'You bow three times. The smoke curls up into the sky with your wish.',
    },
    offer: {
      text: 'Fruit, flowers and cakes for the gods. Pineapple is popular: in Taiwanese, “pineapple” (ông-lâi) sounds like “good luck is coming”.',
      q: 'Which fruit is yellow, spiky and sweet?', // English practice
      a: ['A pineapple.', 'A banana.', 'A grape.'], // English practice
      right: '✅ A pineapple! 旺來 — good luck is coming!',
      wrong: 'Spiky… and yellow…',
    },
    moon: {
      text: 'Moon blocks (擲筊, “poe”): ask the gods a yes-or-no question in your heart, then drop the two red crescent blocks.',
      throw: '🌙 Ask a question and throw',
      results: [
        { name: '聖筊 — Holy answer', text: 'One flat side up, one round side up: the answer is YES!', en: 'The answer is yes!' }, // English practice
        { name: '笑筊 — Laughing answer', text: 'Both flat sides up: the gods are laughing. Your question isn’t clear — ask again!', en: 'Please ask again.' }, // English practice
        { name: '陰筊 — Angry answer', text: 'Both round sides up: the answer is NO, or not now.', en: 'The answer is no.' }, // English practice
      ],
      again: '🌙 Throw again',
    },
    sticks: {
      text: 'Fortune sticks (求籤): shake the bamboo cup until one numbered stick falls out, then find its poem in the little drawers.',
      shake: '🎋 Shake the cup',
      got: 'Stick number {n} falls out! Your fortune says:',
      fortunes: [
        'Slow and steady wins the race. Keep going!', // English practice
        'A good friend will help you very soon.', // English practice
        'Be brave and say hello: a new friend is waiting.', // English practice
        'Your hard work will grow like a tree.', // English practice
        'Share what you have, and happiness comes back to you.', // English practice
        'Listen carefully today: you will learn something important.', // English practice
        'After the rain comes the rainbow.', // English practice
        'Your family is proud of you.', // English practice
      ],
    },
    roof: {
      text: 'Look up! The roof ends sweep up like a swallow’s tail (燕尾脊). The ridges are covered with dragons and tiny figures made of broken coloured porcelain (剪黏).',
      q: 'What bird do the roof ends look like?', // English practice
      a: ['A swallow.', 'A penguin.', 'A chicken.'], // English practice
      right: '✅ A swallow! That’s why they are called swallowtail roofs.',
      wrong: 'A small bird with a forked tail…',
    },
    herbTea: {
      vendor: 'Herbal tea! It cools you down. Hot or cold?', // English practice
      ok: 'A cup of cold herbal tea, please.', // English practice
      bad: ['Herb me cold!', 'I am a herbal tea.'], // English practice
      done: 'Here you go. It’s a little bitter, but perfect on a hot day!', // English practice
    },
    herbSign: {
      text: 'Herb Alley (青草巷): for more than a hundred years these shops have sold fresh green herbs for herbal tea and old home remedies.',
      phrase: 'These herbs smell fresh.', // English practice
    },
    bopiliao: {
      text: 'Bopiliao (剝皮寮) is one of the best-kept old streets in Taipei: red-brick shophouses from the Qing dynasty and the Japanese era, with covered arcades (騎樓) to keep people out of the rain.',
      q: 'What are the old buildings made of?', // English practice
      a: ['Red bricks.', 'Glass.', 'Snow.'], // English practice
      right: '✅ Red bricks! And the arcades keep the sun and rain off.',
      wrong: 'Look at the walls: they are red…',
    },
    huaxi: {
      text: 'Huaxi Street Night Market (華西街夜市) is one of Taipei’s oldest night markets, with a covered street behind its ornate red gate. The stalls open in the evening.',
    },
    hxNoodle: {
      vendor: 'Danzai noodles! Small bowls, big taste. How many?', // English practice
      ok: 'One bowl of danzai noodles, please.', // English practice
      bad: ['Noodle one me!', 'I would like a bowl of chopsticks.'], // English practice
      done: 'Here you are! Shrimp, pork and a little egg on top.', // English practice
    },
    hxSoup: {
      vendor: 'Four-herb soup, nice and warm. Want one?', // English practice
      ok: 'Can I have a four-herb soup, please?', // English practice
      bad: ['Soup! Give!', 'I am four herbs.'], // English practice
      done: 'Here! It’s good for your tummy.', // English practice
    },
    chess: {
      text: 'Two grandpas play Chinese chess (象棋) under the banyan tree. A crowd watches and gives advice nobody asked for!',
      q: 'In chess, what do you say when you attack the king?', // English practice
      a: ['Check!', 'Hello!', 'Goodbye!'], // English practice
      right: '✅ “Check!” Grandpa laughs: “Your move!”', // English practice
      wrong: 'It’s a short word… it starts with “ch”.',
    },
    pigeons: {
      text: 'A flock of pigeons pecks around the park, then flies up all together.',
      q: 'Count them in English! How many pigeons?', // English practice
      a: ['Eleven.', 'Seven.', 'Twenty.'], // English practice
      right: '✅ Eleven! Well counted.',
      wrong: 'Count again, slowly!',
    },
    canoe: {
      text: '“Bangka” (艋舺), the old name of Wanhua, comes from the Ketagalan word for a canoe. Long ago, people paddled canoes along the river here to trade.',
      phrase: 'Bangka means canoe.', // English practice
    },
    fortune: {
      text: 'The fortune-teller grandpa looks at your hand and smiles.',
      reads: [
        'You will learn a lot of English this year.', // English practice
        'You have a kind heart. People like to be near you.', // English practice
        'Something you lost will come back to you.', // English practice
        'A trip will bring you a happy surprise.', // English practice
      ],
      thanks: 'Thank you, grandpa!', // English practice
    },
    oldIce: {
      vendor: 'Welcome to our old ice shop! Since 1960! What would you like?', // English practice
      ok: 'One bowl of fruit shaved ice, please.', // English practice
      bad: ['Ice fruit me now!', 'I would like a hot snowman.'], // English practice
      done: 'Here you go! Mango, watermelon and pineapple on fluffy ice.', // English practice
    },

    // --- People -----------------------------------------------------------------------------
    talk: {
      xm_teen1: ['We’re waiting for our friends. Everyone meets at Exit 6!', 'English practice: “I’m here! Where are you?”', 'After this we’re getting bubble tea. Half sugar, of course.'],
      xm_teen2: ['My friend is late again… She says “I’m on my way!”', 'Ximending is the best place for photos. Look at all the neon!'],
      xm_teen3: ['Have you tried the photo sticker booth? It makes your eyes so big!', 'English practice: “Let’s take a selfie!”'],
      xm_shopper1: ['These sneakers are on sale: buy one, get one free!', 'English practice: “It’s on sale!” means it’s cheaper than usual.'],
      xm_shopper2: ['I collect sneakers. I have thirty pairs!', 'The shops here open late — around eleven — and close very late.'],
      xm_skater: ['Taipei Cinema Park is the best skate spot. And you can paint the wall!', 'English practice: “Watch this trick!”'],
      xm_artist: ['I make keychains by hand. Each one is different!', 'Come back on Saturday or Sunday for the creative market.'],
      xm_redGuide: ['The Red House opened in 1908 as a market. Later it was a theatre, and a cinema!', 'English practice: “octagon” = 8 sides, “cross” = ✚.'],
      xm_cosplayer: ['I’m dressed as my favourite anime hero today!', 'English practice: “Can I take a photo with you?” — “Sure!”'],
      xm_grandpaX: ['When I was young, Ximending had more than twenty cinemas!', 'Cinema Street still has old theatres. Movies are magic, kid.'],
      xm_volunteer: [],
      xm_fortuneGrandpa: [],
      xm_worshipper1: ['I come here every Sunday to pray for my family.', 'English practice: “I pray for good health.”'],
      xm_worshipper2: ['Longshan Temple is almost three hundred years old. It was built in 1738!', 'Many gods live here: Guanyin, Mazu, and the god of exams too!'],
      xm_incenseAuntie: ['Incense and flowers for the gods! Fresh flowers today.', 'English practice: “Would you like some incense?”'],
      xm_chess2: ['Psst… he should move his horse! Don’t tell him I said so.', 'In Chinese chess the pieces are round, with characters on them.'],
      xm_pigeonKid: ['The pigeons all fly up together when someone runs! Shh, walk slowly.', 'English practice: “Look! They’re flying!”'],
      xm_bopiliaoGuide: ['I’m studying the history of Wanhua. This was the busiest port in Taipei!', 'Movies are filmed on this street because it looks so old.'],
      xm_nightVendor: ['The night market opens at five. Come hungry!', 'English practice: “What do you recommend?” — “The danzai noodles!”'],
      xm_taichi: ['Tai chi every morning keeps me young! Slow… and… breathe.', 'English practice: “Breathe in… breathe out.”'],
    } as Record<string, string[]>,
    tourist: {
      ask: 'Excuse me! How do I get to the Red House?', // English practice
      a: ['Cross Chengdu Road. It’s on the other side, near Exit 1.', 'Turn into a cinema and jump.', 'I am the Red House.'], // English practice
      right: '✅ “Thank you so much! You speak great English!”', // English practice
      wrong: 'The tourist looks confused. Try again!',
    },
    tourist2: {
      ask: 'Excuse me, which door do I use to go into the temple?', // English practice
      a: ['The right door — the Dragon Door.', 'The middle door, it’s the biggest.', 'Any window is fine.'], // English practice
      right: '✅ “The Dragon Door, thank you! And out by the Tiger Door?” — “Yes!”', // English practice
      wrong: 'Hmm… remember the dragon and the tiger!',
    },
    chessTalk: '“Your move!” The grandpa waits for you to watch closely.', // English practice
    incenseBuy: '🌸 Buy incense (5 coins)',
    incenseBought: 'You bought three sticks of incense. Use them at the great burner!',
  },
};
